import { EventCatalogFromKeys, EventType } from "../types";

export const GenericEventKeys = {
  APP_LOADED: "app-loaded",
  AUTH_PAGE_VIEW: "auth-page-view",
  PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_ATTEMPT:
    "public-volunteer-signup-form-submit-attempt",
  PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_FAILURE:
    "public-volunteer-signup-form-submit-failure",
  PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_SUCCESS:
    "public-volunteer-signup-form-submit-success",
  PUBLIC_VOLUNTEER_SIGNUP_FORM_VALIDATION_ERROR:
    "public-volunteer-signup-form-validation-error",
} as const;

export const GenericEventCatalog: EventCatalogFromKeys<
  typeof GenericEventKeys
> = {
  [GenericEventKeys.APP_LOADED]: {
    description: "Application loaded",
    eventType: EventType.BASE,
    id: GenericEventKeys.APP_LOADED,
  },
  [GenericEventKeys.AUTH_PAGE_VIEW]: {
    description: "Auth page was viewed",
    eventType: EventType.PAGE_VIEW,
    id: GenericEventKeys.AUTH_PAGE_VIEW,
  },
  [GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_ATTEMPT]: {
    description: "Public volunteer signup form submit attempt",
    eventType: EventType.FORM_SUBMISSION,
    id: GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_ATTEMPT,
  },
  [GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_FAILURE]: {
    description: "Public volunteer signup form submit failure",
    eventType: EventType.ERROR,
    id: GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_FAILURE,
  },
  [GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_SUCCESS]: {
    description: "Public volunteer signup form submit success",
    eventType: EventType.FORM_SUBMISSION,
    id: GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_SUBMIT_SUCCESS,
  },
  [GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_VALIDATION_ERROR]: {
    description: "Public volunteer signup form validation error",
    eventType: EventType.ERROR,
    id: GenericEventKeys.PUBLIC_VOLUNTEER_SIGNUP_FORM_VALIDATION_ERROR,
  },
};
